import { useEffect } from 'react';
import { scrollTop } from '@/helpers/utils';
import { Pagination } from '@/components/Pagination';
import { useWindowSize } from '@/hooks/useWindowSize';
import { useGetCashMovementsList } from '@/query/queries/report/useGetCashMovementsList';
import { Table } from './table';
import { List } from './list';
import s from './index.module.scss';

export const DataView = ({ params, setParams }) => {
  const { isMobile } = useWindowSize();
  const { data, isLoading } = useGetCashMovementsList({
    page: params.page,
    date_from: params.range[0],
    date_to: params.range[1],
    operation_types: params.operation_types,
    grouping: JSON.stringify(params.grouping),
  });

  useEffect(() => {
    scrollTop();
  }, [params.page]);

  return (
    <div className={s.wrapper}>
      {isMobile ? (
        <List isLoading={isLoading} data={data} />
      ) : (
        <Table isLoading={isLoading} data={data} />
      )}
      {data?.total_pages > 0 && (
        <Pagination
          currentPage={params.page - 1}
          totalPages={data?.total_pages}
          onPageChange={({ selected }) =>
            setParams(prev => ({ ...prev, page: selected + 1 }))
          }
        />
      )}
    </div>
  );
};
